// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"spinner_spinnerContainer__BaTtg"};